import React from 'react';
import { Container } from 'reactstrap';
import MenuView from './Components/MenuView';

const Test = () => {
  document.title = 'Menu Management';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <MenuView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Test;
